import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { API } from "@/lib/api";
import { BLOGSMETA } from "@/data/blogsmeta";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { BlogCard } from "@/components/BlogCard";

export function BlogPreview() {
  const [posts, setPosts] = useState((BLOGSMETA || []).slice(0, 6));
  useEffect(() => {
    API.get("/blogs").then((r) => {
      if (r?.data?.items?.length) setPosts(r.data.items.slice(0, 6));
    }).catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <section className="py-16 sm:py-24 lg:py-32" data-testid="blog-preview-section">
      <div className="container-rw">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <SectionHead
            eyebrow="SEO Insights"
            title="SEO insights without the fluff."
            description="Practical guides written by practitioners: technical SEO, keywords, content, local and e-commerce."
            testid="blog-preview-head"
          />
          <Link to="/blog" data-testid="blog-preview-all"
            className="inline-flex items-center gap-2 rounded-full border border-rw-border2 px-6 py-3 text-sm font-semibold text-rw-text hover:border-rw-green/60 hover:text-rw-green transition-all">
            Read SEO Guides <ArrowUpRight size={15} />
          </Link>
        </div>
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {posts.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 0.08}>
              <BlogCard post={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
